"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _PricingSelectors = require("pricing-pages-unified-ui/selectors/PricingSelectors");

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _MerchandiseIdBillingNameKeyMap = _interopRequireDefault(require("self-service-api/constants/MerchandiseIdBillingNameKeyMap"));

var _RequiredOnboardingSubtext = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/RequiredOnboardingSubtext"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _PricingSelectors2 = require("../../selectors/PricingSelectors");

var RequiredOnboardingSection = function RequiredOnboardingSection(_ref) {
  var activeCurrencyCode = _ref.activeCurrencyCode,
      requiredOnboardingMerchId = _ref.requiredOnboardingMerchId,
      pricingInfo = _ref.pricingInfo;

  if (requiredOnboardingMerchId && pricingInfo) {
    var billingNameKey = _MerchandiseIdBillingNameKeyMap.default[requiredOnboardingMerchId];
    return _react.default.createElement(_RequiredOnboardingSubtext.default, {
      billingNameKey: billingNameKey,
      pricingInfo: pricingInfo,
      currencyCode: activeCurrencyCode,
      showDiscountedPriceNov1: requiredOnboardingMerchId === _MerchandiseIds.SERVICE_SALES_PROFESSIONAL_ONBOARDING_NOV_2019 || requiredOnboardingMerchId === _MerchandiseIds.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING_NOV_2019
    });
  }

  return null;
};

RequiredOnboardingSection.propTypes = {
  requiredOnboardingMerchId: _propTypes.default.number,
  //from connect
  activeCurrencyCode: _propTypes.default.string.isRequired,
  pricingInfo: _propTypes.default.object
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var requiredOnboardingMerchId = _ref2.requiredOnboardingMerchId,
      activeTermId = _ref2.activeTermId;
  var pricingInfo = requiredOnboardingMerchId ? (0, _PricingSelectors.calculatedPriceSelector)(state, {
    merchandiseId: requiredOnboardingMerchId,
    termId: activeTermId,
    itemConfigurations: [{
      merchandiseId: requiredOnboardingMerchId,
      quantity: 1
    }]
  }) : null; // Hacky 11/1 discounted onboarding logic:
  // If we're trying to get the price of the new Pro onboarding SKUs,
  // just override and use getCalculateDiscountedOnboardingPriceSelector to get the discounted price

  var isNewSalesOrServiceProOnboarding = requiredOnboardingMerchId === _MerchandiseIds.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING_NOV_2019 || requiredOnboardingMerchId === _MerchandiseIds.SERVICE_SALES_PROFESSIONAL_ONBOARDING_NOV_2019;

  if (isNewSalesOrServiceProOnboarding) {
    pricingInfo = (0, _PricingSelectors2.getCalculateDiscountedOnboardingPriceSelector)(state)({
      onboardingMerchId: requiredOnboardingMerchId
    });
  }

  return {
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    pricingInfo: pricingInfo
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(RequiredOnboardingSection);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/RequiredOnboardingSection.js
// module id = 815
// module chunks = 5 6